export const getLanguageTag = (language) => 
  `language:${language === "ko" ? "korean" : "english"}`;

export const hasLanguageTag = (item, language) => {
  const languageTag = getLanguageTag(language);
  return item.tags && item.tags.some(tag => 
    tag.toLowerCase() === languageTag.toLowerCase() ||
    tag.toLowerCase() === `language:${language.toLowerCase()}`
  );
}; 